import { memo, useEffect, useState } from 'react';

import { displayDuration, getDuration } from 'utils';
import { LiveWaveIcon } from 'components/Icon';

import styles from './UpcomingEventDetail.module.scss';

export type CountdownProps = {
  startDate: string;
};

const Countdown = memo<CountdownProps>(({ startDate }) => {
  const [duration, setDuration] = useState(() => getDuration(startDate));

  const overdue = new Date() > new Date(startDate);
  const startsSoon = getDuration(startDate) <= 1000 * 60 * 30;

  useEffect(() => {
    const durationInterval = setInterval(() => {
      setDuration(() => getDuration(startDate));
    }, 1000);

    return () => {
      clearInterval(durationInterval);
    };
  }, [startDate]);

  const renderContent = () => {
    if (overdue) {
      return 'Video chat will start soon';
    }

    if (startsSoon) {
      return (
        <>
          Starts in <b>{displayDuration(duration)}</b>
        </>
      );
    }

    return null;
  };

  return (
    <div className={styles.countdown}>
      <LiveWaveIcon width={16} height={16} className="mr-4" />
      <span>{renderContent()}</span>
    </div>
  );
});

export default Countdown;
